import { BRAND } from "@/lib/brand";
import { CTAButton } from "./Button";

export type CTAType = "audit" | "roundtable" | "strategy";

const PRESETS: Record<
  CTAType,
  { eyebrow: string; title: string; body: string; href: string; label: string }
> = {
  audit: {
    eyebrow: "Free · Instant",
    title: "See how buyers, sellers, and AI find you.",
    body: "Get your free Visibility Audit in minutes. See exactly where your online presence stands today - and what's quietly costing you business.",
    href: BRAND.links.visibilityAudit,
    label: "Get Your Visibility Audit",
  },
  roundtable: {
    eyebrow: "Invitation Only",
    title: "Hear what Kristan tells her team - every month.",
    body: "Request an invite to the Monthly Market Round Table. Seats are limited and invitations are extended based on fit and availability.",
    href: BRAND.links.roundTable,
    label: "Request an Invitation",
  },
  strategy: {
    eyebrow: "1:1 Conversation",
    title: "Let's build your next 90 days.",
    body: "Book a private Growth Strategy Session with our team. We'll map your next 90 days - whether or not KCN is the right fit.",
    href: BRAND.links.strategyCall,
    label: "Book a Growth Strategy Session",
  },
};

export function CTABanner({
  cta = "roundtable",
  eyebrow,
  title,
  body,
}: {
  cta?: CTAType;
  eyebrow?: string;
  title?: string;
  body?: string;
}) {
  const preset = PRESETS[cta];
  return (
    <section className="bg-surface border-y border-border">
      <div className="container-edge py-14 lg:py-16 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <p className="eyebrow mb-5">{eyebrow ?? preset.eyebrow}</p>
          <h2 className="headline-md max-w-3xl">{title ?? preset.title}</h2>
          <p className="mt-5 text-foreground/90 max-w-2xl">{body ?? preset.body}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3">
          <CTAButton href={preset.href} size="lg" className="w-full" variant="primary">
            {preset.label}
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
